import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, isEmptyArray, isEmptyVariable} from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import { AddNewButtonLayout, DialogSaveButton, TableIcon } from '../../common/Global/globalStyles.style';
import AlertDialog from '../../common/AlertDialog';
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";

let userDetails = getLocalStorageVariables();

class FrameworkInfoDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            frameworkInfo:[],
            showBtnLoader:false,
            alertDialogHeading:"",
            proceedBtnLabel:"",
            deleteFrameworkInfoId:"",
            showAlertDialog:false,
            alertDialogMessage:"",
            selectedFrameworkInfoId:"",
            selectedInfoKey:"",
            selectedInfoValue:"",
            isEdit:false,
            formErrors: {},
            selectedItem: {},
            submitClickedAtleastOnce: false,
            hoveredItemId: null,
            isDrag:false,
            componentDidMountFlag:false,
            showLoader:false,
            info:[],
            isButtonDisabled: false,
            isDisplay:false
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showInfoDialog){
            this.setState({
                isEdit:false,
                selectedItem:{},
                formErrors:{},
                submitClickedAtleastOnce: false,
                isDrag:false,
                componentDidMountFlag:false,
                showLoader:false,
                isButtonDisabled: false,
                isDisplay:false,
                info:[],
            }, () => {
                this.getFrameworkInfo();
            })
        }
    }

    // Handle info Order
    handleReorder = () => {
        const { frameworkInfo, selectedItem } = this.state;
        frameworkInfo.map(item => {
            if(item.frameworkInfoId == selectedItem.frameworkInfoId){
                item.type = selectedItem.type;
                item.info = selectedItem.info;
                return item;
            }
        })
        this.setState({
            isDrag:true,
            isEdit:false,
            frameworkInfo:frameworkInfo,
            selectedItem:{},
            formErrors:{}
        })
    }

    // Sets the hovered item ID when mouse enters a table row
    handleMouseEnter = (itemId) => {
        this.setState({ hoveredItemId: itemId });
    }

    // Resets the hovered item ID when mouse leaves a table row
    handleMouseLeave = () => {
        this.setState({ hoveredItemId: null });
    }

    // Handles the edit action for a selected item
    onHandleEdit = (item) => {
        this.setState({
            isEdit:true,
            selectedItem:{...item},
            isDrag:false
        });
    }

    // Handles the delete action for a selected item, setting up the alert dialog
    onHandleDelete = (item) => {
        this.setState({
            alertDialogHeading:"Delete Framework Information",
            proceedBtnLabel:"Delete",
            deleteFrameworkInfoId:item.frameworkInfoId,
            showAlertDialog:true,
            alertDialogMessage:"Are you sure you want to delete framework information "+item.type + " : " + item.info +"?"
        })
    }

    // Closes the alert dialog and resets its state
    handleAlertDialogClose = () => {
        this.setState({
            alertDialogHeading:"",
            proceedBtnLabel:"",
            deleteFrameworkInfoId:"",
            showAlertDialog:false,
            alertDialogMessage:"",
        })
    }

    // Handles changes in the input fields of the framework info table
    handleChange = (e, index) => {
        const { name, value } = e.target;
        let FormErrorsTemp  = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp[`${name}_${index}`] = "";
        }
        const frameworkInfo = [...this.state.frameworkInfo];
        frameworkInfo[index][name] = value;
        this.setState({ 
            frameworkInfo,
            formErrors:FormErrorsTemp,
         });
    }

    // Handles changes in the input fields and updates the state accordingly.
    handleAddChange = (e, index) => {
        const { name, value } = e.target;
        let FormErrorsTemp  = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp[`${name}_${index}`] = "";
        }
        const info = [...this.state.info];
        info[index][name] = value;

        // Add New button disabled, if type and info is empty.
        const isDisabled = info.some(entry => entry.type === "" || entry.info === "");

        this.setState({ 
            info,
            formErrors:FormErrorsTemp,
            isButtonDisabled:isDisabled
         });
    }

    // Adds a new info entry to the state.
    addInfoKey = () => {
        let info = [...this.state.info];
        info.push({
            type:"",
            info:"",
            infoOrder:info.length + this.state.frameworkInfo.length + 1
        })
        // Add New button disabled, if type and info is empty.
        const isDisabled = info.some(entry => entry.type === "" || entry.info === "");

        this.setState({ 
            info,
            isButtonDisabled:isDisabled,
            isDisplay:true
        })
    }

    // Deletes an info entry from the state and updates the order of remaining entries.
    deleteInfoKey = (index) => {
        let info = [...this.state.info];
        // Get the order of the item being removed
        const removedItemOrder = info[index].infoOrder;

        info.splice(index, 1)
        info.forEach(item => {
            if (item.infoOrder > removedItemOrder) {
                item.infoOrder -= 1;
            }
        })

        // Add New button disabled, if type and info is empty.
        const isDisabled = info.some(entry => entry.type === "" || entry.info === "");

        this.setState({ 
            info,
            isButtonDisabled:isDisabled
        })
    }

    // Handle drag and drop reordering
    onDragEnd = (result) => {
        const { source, destination } = result;

        // Check if the item is dropped outside the droppable area
        if(!destination){
            return
        }

        // Check if the item is dropped in the same position
        if(destination.droppableId === source.droppableId &&
            destination.index === source.index){
                this.setState({
                    isDrag:false
                })
            return
        }

        let newPosition = destination.index;
        let oldPosition = source.index;

        // Get the current frameworkInfo state
        let frameworkInfo = [...this.state.frameworkInfo];

        // Reorder items locally
        let fieldObj = frameworkInfo[oldPosition];
        frameworkInfo.splice(oldPosition, 1)//remove from old position
        frameworkInfo.splice(newPosition, 0, fieldObj);//move the field Obj to new pos

        // Update the order for all items
        let updatedFrameworkInfo = frameworkInfo.map((item,idx)=>{
            return { ...item, infoOrder: idx + 1 };
        })

        this.setState({
            frameworkInfo:updatedFrameworkInfo
        },() => {
            this.updateFrameworkInfoOrder(fieldObj.frameworkInfoId, newPosition + 1, oldPosition + 1)
        })
    };
    /************************API CALLS**************************/
    getFrameworkInfo = () => {
        fetch(Constants.GetFrameworkInfo,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId:this.props.selectedFrameworkId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let frameworkInfo = data.data.frameworkInfo;
                
                this.setState({
                    frameworkInfo:frameworkInfo,
                    componentDidMountFlag:true
                });
            }else{
                this.setState({
                    frameworkInfo:[],
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }

    addFrameworkInfo = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(!isEmptyArray(this.state.info)){
            this.state.info.forEach((item, index) => {
                if(isEmptyVariable(item.type)){
                    isError = true;
                    FormErrorsTemp[`type_${index}`] = "Please enter framework type.";
                }

                if(isEmptyVariable(item.info)){
                    isError = true;
                    FormErrorsTemp[`info_${index}`] = "Please enter framework info.";
                }
            })
        }

        if(isError){
            this.setState({
                formErrors: FormErrorsTemp,
                showLoader: false,
            });
        }else{
            fetch(Constants.AddFrameworkInfo, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    frameworkId:this.props.selectedFrameworkId,
                    keyValueArr:JSON.stringify(this.state.info)
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                        this.setState({
                            showLoader:false,
                            formErrors:{},
                            isDisplay:false,
                            info:[]
                        },()=>{
                            this.getFrameworkInfo();
                        });
                }else{
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage,
                        showLoader:false
                    });
                }
            });
        }
    }

    updateFrameworkInfo = (item, index) => {
        let selectedItem = {...this.state.selectedItem}
        if(selectedItem.type == item.type && selectedItem.info == item.info){
            this.setState({
                isEdit:false,
                selectedItem:{}
            })
        }else{
            this.setState({
                submitClickedAtleastOnce:true,
            });
            
            let isError = false;
            let FormErrorsTemp = {};
    
            if(isEmptyVariable(item.type)){
                isError = true;
                FormErrorsTemp[`type_${index}`] = "Please enter framework type";
            }
            if(isEmptyVariable(item.info)){
                isError = true;
                FormErrorsTemp[`info_${index}`] = "Please enter framework info";
            }
    
            if(isError){
                this.setState({
                    formErrors: FormErrorsTemp,
                });
            }else{
                fetch(Constants.UpdateFrameworkInfo, {
                    method: "POST",
                    mode: "cors",
                    body: new URLSearchParams({
                        email:userDetails.email,
                        accessToken:userDetails.accessToken,
                        frameworkInfoId:item.frameworkInfoId,
                        type:item.type,
                        info:item.info
                    })
                })
                .then(response => { return response.json(); })
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                            this.setState({
                                isEdit:false,
                                selectedItem:{},
                                formErrors:{}
                            },() => {
                                this.getFrameworkInfo();
                            });
                    }else{
                        this.setState({
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage
                        });
                    }
                });
            }
        }
    }

    deleteFrameworkInfo = () => {
        this.setState({
            showBtnLoader:true
        })
        fetch(Constants.DeleteFrameworkInfo,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    frameworkInfoId:this.state.deleteFrameworkInfoId
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        deleteFrameworkInfoId:"",
                        alertDialogHeading:"",
                        proceedBtnLabel:"",
                        alertDialogMessage:"",
                        showAlertDialog:false,
                        showBtnLoader:false
                    },() => {
                        this.getFrameworkInfo();
                    });
                }else{
                    this.setState({
                        deleteFrameworkInfoId:"",
                        alertDialogHeading:"",
                        proceedBtnLabel:"",
                        alertDialogMessage:"",
                        showAlertDialog:false,
                        showBtnLoader:false,
                        alertDialogMessageInfo:data.responseMessage,
                        showAlertDialogInfo:true,
                    })
                }
            });
    }

    updateFrameworkInfoOrder = (frameworkInfoId, newInfoOrder, oldInfoOrder) => {
            fetch(Constants.UpdateFrameworkInfoOrder,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    frameworkInfoId:frameworkInfoId,
                    newInfoOrder:newInfoOrder,
                    oldInfoOrder:oldInfoOrder
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        isDrag:false
                    },()=>{
                        this.getFrameworkInfo();
                    })
                }else{
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage,
                    })
                }
            });
    }

    /************************API CALLS END HERE**************************/

    render() {
        return(
            <>
                <Modal className="custom-dialog" show={this.props.showInfoDialog} onHide={this.props.handleInfoDialogClose} backdrop="static">
                    <Modal.Header>
                        <h5>{"Framework Information"}</h5>
                        <button 
                            onClick={this.props.handleInfoDialogClose}
                            type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        {this.props.isInfoEdit &&
                            <div className="search-addnew-bg">
                                <div className="search-addnew">
                                    <div></div>
                                    <div className="flex-center-layout">
                                        {!isEmptyArray(this.state.frameworkInfo) &&
                                        this.state.frameworkInfo.length > 1 &&
                                            <AddNewButtonLayout themeSettings={this.props.themeSettings} style={{marginRight:10,opacity:this.state.isDrag?1:0.7}}>
                                                <a onClick={this.handleReorder} href="javascript:void(0);">
                                                    <span className="material-icons">reorder</span>
                                                    <p>Reorder</p>
                                                </a>
                                            </AddNewButtonLayout>
                                        }
                                        <AddNewButtonLayout themeSettings={this.props.themeSettings}>
                                            <a onClick={this.addInfoKey} href="javascript:void(0);"
                                                style={{ pointerEvents: this.state.isButtonDisabled ? 'none' : 'auto', opacity: this.state.isButtonDisabled ? 0.5 : 1 }}>
                                                <span className="material-icons">add_circle</span>
                                                <p>Add New</p>
                                            </a>
                                        </AddNewButtonLayout>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.componentDidMountFlag && 
                        !isEmptyArray(this.state.frameworkInfo) &&
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="frameworkInfoList" isDropDisabled={!this.state.isDrag}>
                                    {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef} className="row custom-row">
                                        <div className="col-md-12 custom-col">
                                            <table style={{width:"100%"}}>
                                                <tbody>
                                                    {this.state.frameworkInfo.map((item,index) => {
                                                        let marTop = 10;
                                                        if(index === 0 || index === 1){
                                                            marTop = 0;
                                                        }
                                                        return(
                                                        <Draggable key={item.frameworkInfoId+""} draggableId={item.frameworkInfoId+""} index={index} isDragDisabled={!this.state.isDrag}>
                                                        {(provided,snapshot) => (
                                                            <>
                                                                <tr 
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    ref={provided.innerRef}
                                                                    style={{
                                                                        ...provided.draggableProps.style,
                                                                        height: "32px",
                                                                        backgroundColor: "white",
                                                                        borderBottom:this.state.isDrag?"1px solid #ccc":"0",
                                                                        height: "32px"
                                                                    }}
                                                                    isDragging={snapshot.isDragging}
                                                                    key={item.frameworkInfoId}
                                                                    isDragDisabled={!this.state.isDrag}
                                                                    onMouseEnter={() => this.handleMouseEnter(item.frameworkInfoId)} 
                                                                    onMouseLeave={this.handleMouseLeave}
                                                                >
                                                                    {(this.state.isEdit && (this.state.selectedItem?.frameworkInfoId == item.frameworkInfoId)) ? 
                                                                        <td width={"38%"}>
                                                                            <div className="addnew-modal-form-group mb-0">
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Enter Info key"
                                                                                    spellCheck="true"
                                                                                    name="type"
                                                                                    maxlength="50"
                                                                                    value={item.type}
                                                                                    onChange={(e) => this.handleChange(e, index)}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        :
                                                                        <td width={"33%"} className='align-top'>
                                                                            <div>{item.type}</div>
                                                                        </td>
                                                                    }
                                                                    <td width={"5%"} className={'text-center' + (this.state.isEdit ? '' : ' align-top')}>:</td>
                                                                    {(this.state.isEdit && (this.state.selectedItem?.frameworkInfoId == item.frameworkInfoId)) ? 
                                                                        <td width={"38%"}>
                                                                            <div className="addnew-modal-form-group mb-0">
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Enter Info value"
                                                                                    spellCheck="true"
                                                                                    name="info"
                                                                                    maxlength="200"
                                                                                    value={item.info}
                                                                                    onChange={(e) => this.handleChange(e, index)}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        :
                                                                        <td width={"67%"} className='align-top'>
                                                                            <div>{item.info}</div>
                                                                        </td>
                                                                    }
                                                                    {!this.state.isDrag && this.props.isInfoEdit &&
                                                                        <>
                                                                            <td width={"10%"}>
                                                                                {(this.state.hoveredItemId === item.frameworkInfoId) && !this.state.isEdit ? 
                                                                                    <TableIcon themeSettings={this.props.themeSettings} className="text-center" 
                                                                                    onClick={() => this.onHandleEdit(item, index)}>
                                                                                        <span className="material-icons mx-2">edit</span>
                                                                                    </TableIcon> : <></>
                                                                                }
                                                                                {(this.state.isEdit && (this.state.selectedItem?.frameworkInfoId == item.frameworkInfoId)) ? 
                                                                                    <TableIcon themeSettings={this.props.themeSettings} className="text-center" 
                                                                                        onClick={() => this.updateFrameworkInfo(item, index)}>
                                                                                        <span className="material-icons mx-2">add_circle</span>
                                                                                    </TableIcon> : <></>
                                                                                }
                                                                                
                                                                            </td>
                                                                            <td width={"9%"}>
                                                                                {this.state.hoveredItemId === item.frameworkInfoId ? 
                                                                                    <TableIcon themeSettings={this.props.themeSettings} className="text-center"
                                                                                        onClick={() => this.onHandleDelete(item)}>
                                                                                        <span className="material-icons">delete</span>
                                                                                    </TableIcon> : <></>
                                                                                }
                                                                            </td>
                                                                        </>
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        {(this.state.isEdit && (this.state.selectedItem?.frameworkInfoId == item.frameworkInfoId)) &&
                                                                            !isEmptyVariable(this.state.formErrors[`type_${index}`]) &&
                                                                            <span className="cm-error">{this.state.formErrors[`type_${index}`]}</span>
                                                                        }
                                                                    </td>
                                                                    <td></td>
                                                                    <td>
                                                                        {(this.state.isEdit && (this.state.selectedItem?.frameworkInfoId == item.frameworkInfoId)) &&
                                                                            !isEmptyVariable(this.state.formErrors[`info_${index}`]) &&
                                                                            <span className="cm-error">{this.state.formErrors[`info_${index}`]}</span>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )}
                                                        </Draggable>
                                                        )
                                                    })}
                                                    {provided.placeholder}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        }
                        {this.state.isDisplay &&
                            <div className="addnew-modal-form mt-4">
                                <div className="row custom-row">
                                    <div className="col-md-5 custom-col">
                                        <div className="addnew-modal-form-group">
                                            <p>Type*</p>
                                        </div>
                                    </div>
                                    <div className="col-md-5 custom-col">
                                        <div className="addnew-modal-form-group">
                                            <p>Info*</p>
                                        </div>
                                    </div>
                                </div>
                                {this.state.info.map((item,index) => {
                                    return(
                                        <>
                                        <div key={item.infoOrder} className="row custom-row">
                                            <div className="col-md-5 custom-col">
                                                <div className="addnew-modal-form-group">
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Info key"
                                                        spellCheck="true"
                                                        name="type"
                                                        maxlength="50"
                                                        value={item.type}
                                                        onChange={(e) => this.handleAddChange(e, index)}
                                                    />
                                                    {
                                                        !isEmptyVariable(this.state.formErrors[`type_${index}`]) &&
                                                        <span className="cm-error">{this.state.formErrors[`type_${index}`]}</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-5 custom-col">
                                                <div className="addnew-modal-form-group">
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Info value"
                                                        spellCheck="true"
                                                        name="info"
                                                        maxlength="200"
                                                        value={item.info}
                                                        onChange={(e) => this.handleAddChange(e, index)}
                                                    />
                                                    {
                                                        !isEmptyVariable(this.state.formErrors[`info_${index}`]) &&
                                                        <span className="cm-error">{this.state.formErrors[`info_${index}`]}</span>
                                                    }
                                                </div>
                                            </div>
                                            {this.state.info.length > 1 &&
                                                <div className="col-md-1 custom-col">
                                                    <TableIcon themeSettings={this.props.themeSettings} className="text-center"
                                                    onClick={() => this.deleteInfoKey(index)}>
                                                        <span className="material-icons">delete</span>
                                                    </TableIcon>
                                                </div>
                                            }
                                        </div>
                                        </>
                                    )
                                })}
                                <p style={{fontSize: '12px'}}><strong>*Note:</strong> Cannot enter more than 50 character for type and 200 for info.</p>
                                <div className="modal-close-save">
                                    <div className="close-save-col">
                                        <button onClick={this.props.handleInfoDialogClose} type="button" className="modal-close">Cancel</button>
                                        <DialogSaveButton 
                                        themeSettings={this.props.themeSettings}
                                        onClick={this.addFrameworkInfo} type="button" className="modal-save">
                                            {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                        </DialogSaveButton>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.isEdit &&
                            <p style={{fontSize: '12px'}}><strong>*Note:</strong> Cannot enter more than 50 character for type and 200 for info.</p>
                        }
                        {this.state.componentDidMountFlag && !this.state.isDisplay &&
                            isEmptyArray(this.state.frameworkInfo) &&
                            <div class="no-items-layout">
                                <div class="no-items-card">
                                    <h6>
                                        {Constants.NO_RECORDS_WARNING}
                                    </h6>
                                </div>
                            </div>
                        }
                    </div>
                </Modal>

                <AlertDialog
                    showAlertDialog={this.state.showAlertDialog}
                    handleAlertDialogClose={this.handleAlertDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={this.state.alertDialogHeading}
                    alertDialogMessage={this.state.alertDialogMessage}
                    proceedBtnClick={this.deleteFrameworkInfo}
                    proceedBtnLabel={this.state.proceedBtnLabel}
                    showLoader={this.state.showBtnLoader}
                    themeSettings={this.props.themeSettings}
                />

            </>
        )
    }
}
export default FrameworkInfoDialog;